import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Link } from "./LinkBlock";
import { defaultData } from "./LinkBlockDefaultData";
import { meta } from "./LinkBlockMetaData";

export const LinkBlock: BlockExport = {
  type: "component",
  Block: Link,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-link",
    size: 24,
  },
  meta,
};
